import React, { useState, useEffect } from "react";
import Floaticons from "../Floaticons";
import "./AzureComponent.css";
import { Link, useParams } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import data from "../../data/Courses/trialData.json";  // Dummy Data coming from a json file
import { useDispatch, useSelector } from "react-redux";
import { HashLink } from "react-router-hash-link";
import {
    Box, FormControlLabel, Checkbox, Typography,
    FormGroup, TextField, Button, Input,
    Select, MenuItem, FormControl, InputLabel,Modal,
     Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
     } from "@mui/material";
import { ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';     
import { createTheme, ThemeProvider } from '@mui/material/styles';
import "./AllCourses.css";
import styles from './Skelton.module.css'
import { styled } from '@mui/material/styles';
import axios from "axios";


// import InstructionsPopup from "./Instructions/InstructionsPopup";
import { CircularProgressbar } from "react-circular-progressbar";
// import { Input } from "antd";
// import "react-circular-progressbar/dist/styles.css";
import { EditOutlined, AddAPhoto, CloudUpload, Add, Delete } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';


const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const theme = createTheme({
    palette: {
        primary: {
            main: '#A203FF'
        },

    },
});

const SkeletonComponent = () => {

    const { c_title } = useParams();
    const isAdmin = true;
    const [rdata, setRData] = useState(null); // real data of course coming from DB
    const [editable, setEditable] = useState(0);
    //{1: about-section,2: objectives-section,3: LJ-section,4: Phases-section,5: highlights-section}   
    const [aboutNV, setaboutNV] = useState(''); // about new value
    const [aboutImg, setAboutImg] = useState(null); // will have the file(Image) for the about section uploaded by user

    const [objVal, setObjVal] = useState('');  // will contain the string entered by the user for adding a new objective
    const [openObjDlt, setObjDlt] = useState(false);
    //states for Learning journey section
    const [LjPhaseName, setLjPhaseName] = useState('');
    const [LjPhaseImg, setLjPhaseImg] = useState(null);
    const [LjPhaseLink, setLjPhaseLink] = useState('');

    const [phasesHead, setPhasesHead] = useState('');
    const [phasesIntro, setPhasesIntro] = useState('');
    const [phaseName, setPhaseName] = useState('');
    const [levelDesc, setLevelDesc] = useState('');
    const [targetAudience, setTargetAudience] = useState('');
    const [duration, setDuration] = useState(0);
    const [sheet, setSheet] = useState(null);

    //for utility only  
    const phasesImageArr = {
        'Aware': "/images/Home/Courses/Azure/Aware.png",
        'Equipped': "/images/Home/Courses/Azure/Equipped.png",
        'Competent': "/images/Home/Courses/Azure/Competent.png"
    }

    const arr1 =
        [
            { image: "/images/Home/Courses/Azure/self.png", text: "Self-paced Learning" },
            { image: "/images/Home/Courses/Azure/sme.png", text: "SME Connects" },
            { image: "/images/Home/Courses/Azure/assessment.png", text: "Final Assessment" },
            { image: "/images/Home/Courses/Azure/completion.png", text: "Earn Completion Certificates, Flair, R&R" },
            { image: "/images/Home/Courses/Azure/case.png", text: "End-to-End case studies" },

        ];
    const [highlightsChecklist, setHighlightsChecklist] = useState(Array(arr1.length).fill(false));

    const baseURL = "http://localhost:3045";
    //const baseURL ="https://atci.ABCtalentacademy.accenture.com/abc-talent-apis"


    const [phase, setPhase] = useState(null);
    const [learning, setLearning] = useState(0);
    const [modalContent, setModalContent] = useState({});
    const [openModal, setOpenModal] = useState(false);
    const [showInstructionModal, setShowInstructionModal] = useState(false);
    const [assessmentCourse, setAssessmentCourse] = useState("");
    const dispatch = useDispatch();
    const Max_Length = 110;





    useEffect(() => {

        const fetchCourseDetails = async () => {

            try {
                const response = await fetch(`${baseURL}/course/${c_title}`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const courseData = await response.json();
                setRData(courseData);
                //populating mandatory fields
                setaboutNV(courseData.about);

            } catch (error) {
                console.error('Error fetching course:', error);
            }
        };  


        fetchCourseDetails();
    }, []);


    const helperFunc = () => {
        if (rdata.LJ !== undefined && rdata.LJ.Phases !== undefined && rdata.LJ.Phases.length > 0) {
            return rdata;
        }
        else {
            return data;
        }
    }

    const helperFunc2 = () => {
        if (rdata.phases !== undefined && rdata.phases.heading !== undefined && rdata.phases.intro !== undefined) {
            if (rdata.phases.heading !== "" && rdata.phases.intro !== "") { return rdata; }
            else return data;
        }
        else {
            
            return data;
        }

    }
    const helperFunc4=()=>{
        if(rdata.objectives !== undefined && rdata.objectives.length > 0)return rdata;
        return data;
    }
    const isValidURL = (url) => {
        try {
            new URL(url);
            return true;
        } catch (error) {
            return false;
        }
    }


    const validateImageDimensions = (file) => {
        const maxWidth = 401;
        const minWidth= 341;
        const maxHeight = 173;
        const minHeight = 113;

        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = function () {
                const { naturalWidth, naturalHeight } = img; // Use naturalWidth and naturalHeight to get the actual dimensions
                
                if (naturalWidth <= maxWidth && naturalWidth> minWidth
                     && naturalHeight <= maxHeight && naturalHeight>=minHeight) {
                    resolve(true); // Image dimensions are within limits
                } else {

                    resolve(false); // Image dimensions exceed limits
                }
            };

            img.onerror = function () {
                reject(new Error('Error loading image.'));                
            };

            img.src = URL.createObjectURL(file);
        });
    };

    const validateImageSize = (file, maxSizeMB) => {
        const maxSizeBytes = maxSizeMB * 1024 * 1024; // Convert MB to bytes

        return file.size <= maxSizeBytes;
    };

    const handleAboutSubmit = async (e) => {
        e.preventDefault();

        if (aboutNV.length > 500 || aboutNV.length < 200) {
            alert('`About` should contain 200 to 500 characters.');

            return;
        }

        // Proceed with form submission logic         
        const formData = new FormData();
        formData.append('id', rdata._id);
        formData.append('about', aboutNV);
        formData.append('aboutImage', aboutImg); // Assuming aboutImg is a File object

        try {
            const response = await axios.put(baseURL + '/course/addAbout', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            
            if (aboutImg) { setRData({ ...rdata, about: aboutNV, aboutImagePath: response.data.aboutImagePath }); }
            else { setRData({ ...rdata, about: aboutNV }); }
            toast.success("About Section updated successfully!");
        } catch (error) {
            console.error('Error in updating about:', error);
            // Handle error
            toast.error('Error in updating about section', error);
        }
        setEditable(0);

    }

    const handleAboutImgChange = (e) => {
        const file = e.target.files[0];

        // Validate image dimensions
        validateImageDimensions(file)
            .then((isValidDimensions) => {
                if (!isValidDimensions) {
                    alert('Please choose an image having width between 341px to 401px and height between 113px to 173px');
                    return Promise.reject('Invalid image dimensions');
                }

                // Validate image file size
                const maxSizeMB = 1; // 1MB max size
                return validateImageSize(file, maxSizeMB);
            })
            .then((isValidSize) => {
                if (!isValidSize) {
                    alert(`Please upload an image with size less than 1MB.`);
                    return Promise.reject('Image size exceeds limit');
                }

                // Proceed with setting the image in state
                
                setAboutImg(file);
                
            })
            .catch((error) => {
                //handle error
                console.log(error); 
                toast.error(error);                
            });
    };



    const pushObjective = async (e) => {

        e.preventDefault();
        if (objVal.length > 75) {
            alert("Objective cannot conatin more than 75 characters.");
            return;
        }


        if (rdata.objectives == undefined) rdata.objectives = []//edge case

        try {
            let updatedObjectives = [...rdata.objectives, objVal]
            const response = await axios.post(baseURL + '/course/Objectives',
                { id: rdata._id, objectives: updatedObjectives });
            setRData({ ...rdata, objectives: updatedObjectives });
        } catch (error) {
            console.error('Error in updating objectives:', error);
            // Handle error
        }
        setObjVal('');

        setEditable(0);

    }

    const deleteObjective = async(index) => {
        try {
            const newObjectives = [...rdata.objectives]; 
            newObjectives.splice(index, 1);
            const response = await axios.delete(baseURL + '/course/Objectives', {
                data: {
                    id: rdata._id,
                    objectives: newObjectives
                }
            });
            console.log('Objective deleted successfully');
            
            setRData({ ...rdata, objectives: newObjectives })
          } catch (error) {
            console.error('Error deleting objective:', error);
            
          } finally {
            setObjDlt(false); // Close the modal regardless of success or failure
          }
        
    }


    const handleLJSubmit = async (e) => {

        e.preventDefault();
        if (!isValidURL(LjPhaseLink)) {
            alert("Please enter a valid hyperlink!!");
            return;
        }

        const formData = new FormData();
        formData.append('id', rdata._id);
        formData.append('title', LjPhaseName);
        formData.append('image', LjPhaseImg);
        formData.append('link', LjPhaseLink);

        try {
            const response = await axios.put(baseURL + '/course/addLJ', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            //append to Lj-Phases array 
            const newObj = {
                title: LjPhaseName,
                id: response.data.n,
                link: LjPhaseLink,
                imgLink: response.data.imagePath
            }
            const n= response.data.n;
           // Update rdata.LJ.Phases based on your described logic
    const newPhases = [...rdata.LJ.Phases]; // Assuming LJ.Phases is an array

    // Ensure there are enough elements in newPhases to insert at index n
    while (newPhases.length <= n) {
        newPhases.push(null); // Initialize with null until index n is reached
    }

    // Insert newObj at index n
    newPhases[n] = newObj;

    // Set the updated rdata with the new LJ.Phases
    setRData({
        ...rdata,
        LJ: {
            ...rdata.LJ,
            Phases: newPhases
        }
    });
    toast.success('Updated LJ-Phase successfully!',);
        } catch (error) {
            console.error('Error in updating LJ-Phase:', error);
            // Handle error
            toast.error('Error in updating LJ-Phase:', error);
        }


        setLjPhaseName('');
        setLjPhaseImg(null);
        setLjPhaseLink('');
        setEditable(0);
    }


    const handlePhasesSubmit = async (e) => {

        e.preventDefault();
        if (phasesHead.length > 80 || phasesHead.length <= 0) {
            alert("Heading can't be empty or conatin more than 80 characters");
            return;
        }
        else if (phasesIntro.length > 800 || phasesIntro.length <= 200) {
            alert("Introduction paragraph should contain 200 to 800 characters");
            return;
        }

        try {
            const response = await axios.put(baseURL + '/course/phases',
                { id: rdata._id, heading: phasesHead, intro: phasesIntro }
            );

            setRData(prevState => ({
                ...prevState,
                phases: {
                    ...prevState.phases,
                    heading: phasesHead,
                    intro: phasesIntro
                },
            }));
            

        } catch (error) {
            console.log('error in updating phases-Section ', error);
        }

        setPhasesHead('');
        setPhasesIntro('');
        setEditable(0);
    }


    const populatePhaseData = (e) => {
        const selectedPhaseName = e.target.value;
        setPhaseName(selectedPhaseName);
        console.log('here--88');

        // Find the object in rdata.phases.phaseInfo array where title matches selectedPhaseName
        const selectedPhase = rdata.phases.phaseInfo.find(phase =>phase && phase.title === selectedPhaseName);//here skip comparing where phase===null
        if (selectedPhase) {
            setLevelDesc(selectedPhase.levelDesc);
            setDuration(selectedPhase.duration);
            setTargetAudience(selectedPhase.targetAudience);
        }
        else {
            setLevelDesc("");
            setDuration(0);
            setTargetAudience("");

        }
    }

    const handleAddPhase = async (e) => {
        e.preventDefault();

        if (levelDesc.length < 90) {
            alert("Level Description should be atleast of 90 characters");
            return;
        } else if (targetAudience === '') {
            alert("Please Enter the Target audience for this phase");
            return;
        }

        const formData = new FormData();
        formData.append('id', rdata._id);
        formData.append('phaseName', phaseName);
        formData.append('levelDesc', levelDesc);
        formData.append('targetAudience', targetAudience);
        formData.append('duration', duration);
        formData.append('sheet', sheet);


        try {
            const response = await axios.post(baseURL + '/course/addPhaseInfo', formData, {
                headers: {
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }
            }
            );
            const n= response.data.n;
            const newPhases = [...rdata.phases.phaseInfo];

            // Ensure there are enough elements in newPhases to insert at index n
            while (newPhases.length <= n) {
                newPhases.push(null); // Initialize with null until index n is reached
            }

            const newObj = {
                title: phaseName,
                levelDesc,
                targetAudience,
                duration,
                coursesData: response.data.coursesObj
            }
            newPhases[n] = newObj;
            setRData({
                ...rdata,
                phases: {
                    ...rdata.phases,
                    phaseInfo: newPhases
                }
            });
            toast.success('Successfully Posted phase data');
            //   console.log(response.data.message);
        } catch (error) {
            toast.error('error in posting Phase ', error);

        }
        setPhaseName('');
        setLevelDesc('');
        setTargetAudience('');
        setDuration('');
        setSheet(null);
        setEditable(0);
    };


    const handleCheckboxChange = (index) => (event) => {
        const checked = event.target.checked;
        setHighlightsChecklist(prevState => {
            const newState = [...prevState];
            newState[index] = checked;
            return newState;
        });
    }

    const handleHighlightsSubmit = async () => {

        const selectedOptions = highlightsChecklist.reduce((acc, isChecked, index) => {
            if (isChecked) {
                acc.push(index); // Push number index into selectedOptions array
            }
            return acc;
        }, []);


        try {
            const response = axios.post(baseURL + '/course/highlight',
                { id: rdata._id, program_highlights: selectedOptions });

            setRData(prevRData => ({
                ...prevRData,
                program_highlights: selectedOptions
            }));

        } catch (error) {
            console.log("Failed to update highlights", error);
        }

        setEditable(0);
    }

    const handleAbort = (n) => {
        switch (n) {
            case 1: {


            }
                break;
            case 2: {
                setObjVal('');

            }
                break;
            case 3: {
                setLjPhaseName('');
                setLjPhaseImg(null);
                setLjPhaseLink('');
            }
                break;
            case 4: {
                setPhasesHead('');
                setPhasesIntro('');
            }
                break;
            case 5: {
                setHighlightsChecklist(Array(arr1.length).fill(false));
            }
                break;
            case 6: {
                setPhaseName('');
                setLevelDesc("");
                setDuration(0);
                setTargetAudience("");
                setSheet(null);
            }
        }
        setEditable(0);
    }

    function handleClick(event) {
        console.info("You clicked a breadcrumb.");
    }
    const breadcrumbs = [
        <Link
            underline="hover"
            key="1"
            color="inherit"
            href="/FedExTalentAcademy/home"
            onClick={handleClick}
        >
            MUI
        </Link>,
        <Link
            underline="hover"
            key="2"
            color="inherit"
            // href="/material-ui/getting-started/installation/"
            href="/home#Offerings"
        // onClick={handleClick}
        >
            Core
        </Link>,
        <Typography key="3" color="text.primary">
            Breadcrumb
        </Typography>,
    ];
    const handleOpen = (title) => {
        setOpenModal(true);
        const clickedCourseDetail = rdata.phases.phaseInfo.filter((obj) => {
            if(obj===null) return false;
            return obj.title === title;
        });
        setModalContent(clickedCourseDetail[0]);
    };

    const handleClose = () => {
        setOpenModal(false);
    };

    const handleAssessment = (course) => {
        setShowInstructionModal(true);
        setAssessmentCourse(course);
    };
    if (rdata) return (
        <>
         <ToastContainer 
         position="top-center" 
         autoClose={2500}/>
        <ThemeProvider theme={theme}>
            <div className="main-banner">
                <img src={process.env.PUBLIC_URL + "/images/Home/Courses/Azure/TAA-Banner.png"} alt="banner" className="banner-img" />
                {/* <img src="images/Home/banner-strip.png" alt="strip" className="strip-img" /> */}
                <div className="announcemnt-box">
                    <p>
                        <img src={process.env.PUBLIC_URL + "/images/Home/speaker.png"} alt="speaker" className="speaker-img" />
                        <marquee
                            width="92%"
                            direction="left"
                            style={{ display: "inline-block", verticalAlign: "middle" }}
                        >
                            <b>Come Join Us</b> on an exhilarating learning Journey on ABC Talent Academy!!
                        </marquee>
                    </p>
                </div>
                <Floaticons />

            </div>
            <>
                <ul className="breadcrumbs">
                    <li className="breadcrumbs-item">
                        <HashLink className="breadcrumbs-links" to="/home">
                            {/* Home */}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                            >
                                <path d="M 12 2.0996094 L 1 12 L 4 12 L 4 21 L 11 21 L 11 15 L 13 15 L 13 21 L 20 21 L 20 12 L 23 12 L 12 2.0996094 z M 12 4.7910156 L 18 10.191406 L 18 11 L 18 19 L 15 19 L 15 13 L 9 13 L 9 19 L 6 19 L 6 10.191406 L 12 4.7910156 z"></path>
                            </svg>
                        </HashLink>
                        <span>
                            <FiChevronRight color="lightgray" />
                        </span>
                    </li>
                    <li className="breadcrumbs-item">

                        <HashLink className="breadcrumbs-links" to="/home#Offerings">
                            Technology Learning
                        </HashLink>
                        <span>
                            <FiChevronRight color="#5f5f5f" />
                        </span>
                    </li>
                    <li className="breadcrumbs-item">
                        <a
                            activeClassName="is-active"
                            className="breadcrumbs-links"
                            href={`/courses/${c_title}`}
                            // style={{color: window.location.pathname.slice(-5) == "azure" && "#5f5f5f"}}
                            style={{ color: "#5f5f5f" }}
                        >
                            <cap>{rdata.title}</cap>
                        </a>
                    </li>
                </ul>
                {/* About Azure Section */}
                <div>
                    <div className="about-skill-container">
                        <div className="about-skill-h2-wrap">
                            <h2>About <cap>{rdata.title}</cap></h2><br />
                            {isAdmin &&
                                <Button style={{ color: "black", textTransform: 'none' }}
                                    variant="outlined" size="small" onClick={() => setEditable(1)}>
                                    <img height="12px" src={process.env.PUBLIC_URL + "/images/Home/Courses/Azure/EditIcon.png"} />
                                    &nbsp;Edit</Button>}
                        </div>


                        {editable === 1 ?
                            <FormGroup row='true'>
                                {/* <label htmlFor="EditAbout">Enter About</label><br/> */}
                                <div className={styles.center}>
                                    <textarea value={aboutNV} required
                                        onChange={(e) => setaboutNV(e.target.value)} rows="4" cols="85"
                                        placeholder="Enter about here..."
                                        id="EditAbout" />
                                    <input type="file" id="fileInput" onChange={handleAboutImgChange}
                                        accept=".jpg, .jpeg, .png, .gif, .jfif"
                                        style={{ display: 'none' }} />
                                    <label htmlFor="fileInput">
                                        <uploadImg><AddAPhoto /> Choose Image</uploadImg>
                                        <center>{aboutImg === null ?
                                                <instruct>Please Choose a image</instruct>
                                                :
                                                aboutImg.name}
                                            </center>
                                    </label>
                                </div>
                                <div className={styles.center}>
                                    <Button className={styles.btn}
                                        variant="contained" type='submit'
                                        onClick={handleAboutSubmit}>Submit</Button>
                                    <Button className={styles.btn} variant="outlined" color="error" onClick={() => handleAbort(1)}>Cancel</Button>
                                </div>
                            </FormGroup>
                            :
                            <>
                                <div className="about-skill-wrap">
                                    <p>
                                        {rdata.about !== undefined ? rdata.about :
                                            data.about}
                                    </p>
                                    <img
                                        // src="images/Home/Courses/Selenium/info-selenium.png"
                                        src={rdata.aboutImagePath !== undefined && rdata.aboutImagePath !== '' ?
                                            baseURL + '/' + rdata.aboutImagePath :
                                            process.env.PUBLIC_URL+"/images/Home/Courses/Azure/About-Default.png"
                                        }
                                        alt="about-skill-image"
                                        className="info-skill"
                                    />
                                </div>
                            </>}
                    </div>

                    {/* Program Objectives Section */}
                    <div className="program-objectives-container">
                        <center><h2>Program Objectives</h2></center>
                        
                        {isAdmin &&
                            <center><Button style={{ color: "black", textTransform: 'none' }}
                                variant="outlined" size="small" onClick={() => setEditable(2)}>
                                <img height="12px" src={process.env.PUBLIC_URL + "/images/Home/Courses/Azure/EditIcon.png"} />
                                &nbsp;Edit</Button></center>}

                        <div className={styles.greyMatter}>

                            <div className="program-objectives-wrap">
                            {(helperFunc4()).objectives
    .map((objective, index) => (
        <div key={index} className="program-objective-section first-program-obj">
            <img
                src={process.env.PUBLIC_URL + "/images/Home/Courses/Azure/programicon.png"}
                alt="program-icon"
                className="program-icon"
            />
            <p>{objective}</p>
            {isAdmin && helperFunc4()==rdata &&
                <>
                    <Button color="error" onClick={() => setObjDlt(index)}>
                        <Delete fontSize="x-small" />
                    </Button>
                    <Dialog open={openObjDlt === index} onClose={() => setObjDlt(false)}>
                        <DialogTitle>Confirm Deletion</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Are you sure you want to remove this objective?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setObjDlt(false)} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={() => deleteObjective(index)} color="error" autoFocus>
                                Delete
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            }
        </div>
    ))}

                            </div>
                            {editable === 2 && (
                                <div className={styles.fullWidthContainer}>
                                    <form>
                                        <TextField
                                            placeholder="Enter new Objective here..."
                                            style={{ backgroundColor: 'white' }}
                                            fullWidth
                                            type="text"
                                            value={objVal}
                                            onChange={(e) => setObjVal(e.target.value)}
                                        />
                                        <Button disabled={objVal === ''}
                                            className={styles.btn} variant="contained" onClick={pushObjective}>
                                            Add
                                        </Button>
                                        <Button className={styles.btn} variant="outlined" color="error" onClick={() => handleAbort(2)}>Cancel</Button>
                                    </form>

                                </div>
                            )}

                        </div>

                    </div>
                    {/* Learning Journey Section */}
                    <div className="learning-journey-container">
                        <div className="learning-journey-wrap">
                            <div className="about-skill-h2-wrap">
                                <h2><cap>{rdata.title}</cap> Learning Journey</h2>   <br />
                                {isAdmin &&
                                    <Button style={{ color: "black", textTransform: 'none' }}
                                        variant="outlined" size="small" onClick={() => setEditable(3)}>
                                        <img height="12px" src={process.env.PUBLIC_URL + "/images/Home/Courses/Azure/EditIcon.png"} />
                                        &nbsp;Edit</Button>}
                            </div>

                            {/* <p className="Skill-Learning-title">{data.LJ.desc}</p> */}
                            <div className="journey-section-container">
                                {editable !== 3 &&

                                    <div className="journey-section-wrap">
                                        {helperFunc().LJ.Phases.map((item) => {
                                            if (!item) return null;
                                            return (
                                                <>
                                                    <div
                                                        className="overall"
                                                        onClick={() => setLearning(item.id)}
                                                    >
                                                        <p
                                                            className={helperFunc().LJ.Phases[learning]&&
                                                                helperFunc().LJ.Phases[learning].title == item.title
                                                                    ? `overall-p-active`
                                                                    : `overall-p`
                                                            }
                                                        >
                                                            {item.title}
                                                        </p>
                                                        <div
                                                            className={helperFunc().LJ.Phases[learning] &&
                                                                helperFunc().LJ.Phases[learning].title == item.title
                                                                    ? "bottom-journey-active"
                                                                    : "bottom-journey"
                                                            }
                                                        ></div>
                                                    </div>
                                                </>
                                            );
                                        })}
                                    </div>


                                }
                                <div className="journey-section-content">
                                    {editable === 3 ?
                                        <FormControl className={styles.ljForm}>
                                            <InputLabel id="demo-simple-select-label">Select Phase</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                label="Select Phase"
                                                value={LjPhaseName}
                                                onChange={(e) => setLjPhaseName(e.target.value)}
                                                required
                                            >
                                                <MenuItem value="Overall">Overall</MenuItem>
                                                <MenuItem value="Aware">Aware</MenuItem>
                                                <MenuItem value="Equipped">Equipped</MenuItem>
                                                <MenuItem value="Competent">Competent</MenuItem>
                                            </Select><br />
                                            <label htmlFor="ImageInput">
                                                <uploadImg><AddAPhoto /> Choose Image</uploadImg>
                                            </label>
                                            <center>{LjPhaseImg === null ?
                                                <instruct>*Please Choose a image</instruct>
                                                :
                                                LjPhaseImg.name}
                                            </center>
                                            <input type="file"
                                                accept=".jpg, .jpeg, .png, .gif, .jfif"
                                                name="attachment" id="ImageInput"
                                                style={{ display: "none" }}
                                                onChange={(e) => setLjPhaseImg(e.target.files[0])} /><br />
                                            <Input type="text"
                                                placeholder="Enter hyperlink here..."
                                                onChange={(e) => setLjPhaseLink(e.target.value)} /><br />
                                            <div className={styles.center}>
                                                <Button className={styles.btn} variant="contained"
                                                    disabled={LjPhaseName === '' || LjPhaseImg === null} onClick={handleLJSubmit}>Submit</Button>
                                                <Button className={styles.btn} variant="outlined"
                                                    color="error" onClick={() => handleAbort(3)}>Cancel</Button>
                                            </div>
                                        </FormControl>
                                        :
                                        <>
                                            {/* <p className="journey-section-title">
                                    <cap>{rdata.title}</cap> LEARNING PATH - 
                                        {helperFunc().LJ.Phases[learning].title}
                                    </p> */}
                                            {helperFunc().LJ.Phases[learning] &&
                                                <a target="_blank" href={helperFunc().LJ.Phases[learning].link}>
                                                    <img className={`${styles.LJimg} SkillLJ`}
                                                        src={helperFunc() === data ? process.env.PUBLIC_URL + '/images/Home/Courses/Azure/LJ-Default.png'
                                                            : `${baseURL}/${helperFunc().LJ.Phases[learning].imgLink}`}
                                                        alt="Skill-Learning-Journey"

                                                    />
                                                </a>}
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* phases section */}
                    <div className="phases-container">
                        <center><div >
                            <h2>{helperFunc2().phases.heading}</h2>
                        </div>
                            {isAdmin &&
                                <Button style={{ color: "black", textTransform: 'none' }}
                                    variant="outlined" size="small" onClick={() => setEditable(4)}>
                                    <img height="12px" src={process.env.PUBLIC_URL + "/images/Home/Courses/Azure/EditIcon.png"} />
                                    &nbsp;Edit</Button>}
                        </center>

                        {editable === 4 ?

                            <FormControl fullWidth>
                                <TextField value={phasesHead}
                                    className={styles.Inn}
                                    onChange={(e) => setPhasesHead(e.target.value)}
                                    placeholder="Enter Heading of the section here..." />
                                <textarea value={phasesIntro}
                                    className={styles.Inn}
                                    onChange={(e) => setPhasesIntro(e.target.value)} rows="4" cols="85"
                                    placeholder="Enter introductory paragraph here..."
                                    id="EditAbout" />
                                <div className={styles.center}>
                                    <Button className={styles.btn} variant="contained"
                                        onClick={handlePhasesSubmit}
                                    >Submit</Button>
                                    <Button className={styles.btn} variant="outlined"
                                        color="error" onClick={() => handleAbort(4)}>Cancel</Button>
                                </div>
                            </FormControl>

                            :
                            <p className="phases-container-heading">
                                {helperFunc2().phases.intro}
                            </p>
                        }
                        {isAdmin &&
                            <center><Button className={styles.btn} style={{ color: "black", textTransform: 'none' }}
                                variant="outlined" size="small" onClick={() => setEditable(6)}>
                                <Add fontSize="small" />
                                &nbsp;Add Phase</Button></center>}

                        {editable === 6 ?


                            <FormGroup onSubmit={handleAddPhase} className={styles.addPhaseForm}>
                                <InputLabel id="demo-simple-select-label">Select Phase</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Select Phase"
                                    value={phaseName}
                                    onChange={populatePhaseData}
                                    required
                                >
                                    <MenuItem value="Aware">Aware</MenuItem>
                                    <MenuItem value="Equipped">Equipped</MenuItem>
                                    <MenuItem value="Competent">Competent</MenuItem>
                                </Select>
                                <br />
                                <label htmlFor="levelDesc">Level Description:</label>
                                <textarea
                                    name="levelDesc"
                                    id="levelDesc"
                                    value={levelDesc}
                                    onChange={(e) => setLevelDesc(e.target.value)}
                                    placeholder="Enter level description here..."
                                />
                                <div>
                                    <label htmlFor="targetAudience">Target Audience:</label>
                                    <input
                                        name="targetAudience"
                                        id="targetAudience"
                                        className={styles.Inn}
                                        type="text"
                                        value={targetAudience}
                                        onChange={(e) => setTargetAudience(e.target.value)}
                                        placeholder="Eg. ASE,SE,SSE"
                                    />
                                    <label htmlFor="duration">Duration(Hrs.):</label>
                                    <input
                                        name="duration"
                                        id="duration"
                                        className={styles.Inn}
                                        type="number"
                                        value={duration}
                                        onChange={(e) => setDuration(e.target.value)}
                                        placeholder="Ex. 50"
                                    />
                                </div>
                                <Button
                                    style={{ margin: "10px", textTransform: "capitalize" }}
                                    component="label"
                                    htmlFor="sheetUpload"
                                    role={undefined}
                                    variant="contained" tabIndex={-1}
                                    startIcon={<CloudUpload />}
                                >
                                    Upload Courses file
                                    <VisuallyHiddenInput type="file" id='sheetUpload'
                                        accept=".xlsx, .xls"
                                        onChange={(e) => setSheet(e.target.files[0])} />
                                </Button>
                                <center>{sheet === null ?
                                    <instruct>*Please Choose a file to upload</instruct>
                                    :
                                    sheet.name}
                                </center>
                                <div className={styles.center}>
                                    <Button className={styles.btn}
                                        disabled={phaseName == ""}
                                        variant="contained"
                                        onClick={handleAddPhase}>Submit</Button>
                                    <Button className={styles.btn} color="error"
                                        variant="outlined" onClick={() => handleAbort(6)}>Cancel</Button>
                                </div>
                            </FormGroup>
                            :
                            <div className="phases-wrap">

                                {rdata.phases.phaseInfo.length > 0 &&

                                    // ToDo: conditional rendering --> start using rdata.phases.sheetRecords instead of SeleniumPhasesData
                                    rdata.phases.phaseInfo.map((item) => {
                                        return (item &&
                                            <>
                                                <div className="card-complete">
                                                    <div className="card-container">
                                                        <img
                                                            src={phasesImageArr[item.title]}
                                                            alt="card-img"
                                                            className="card-img"
                                                        />
                                                        <div className="card-wrap">
                                                            <div className="card-wrap-left">
                                                                <p
                                                                    // style={{ color: "#6c4ab6" }}
                                                                    className="card-wrap-heading"
                                                                >
                                                                    {item.title}
                                                                </p>
                                                                {item.levelDesc.length > Max_Length ? (
                                                                    <p className="tile-desc">
                                                                        {`${item.levelDesc.substring(
                                                                            0,
                                                                            Max_Length
                                                                        )}...`}
                                                                        <span
                                                                            className="knowmore"
                                                                            onClick={() => handleOpen(item.title)}
                                                                            tabIndex={0}
                                                                        >
                                                                            Know More
                                                                        </span>
                                                                    </p>
                                                                ) : (
                                                                    <p className="tile-desc">
                                                                        {item.levelDesc}
                                                                       
                                                                    </p>
                                                                )}
                                                                <p className="target-audience">
                                                                    <strong>Target Audience:</strong>{" "}
                                                                    {item.targetAudience}
                                                                </p>
                                                                {/* <div className="assessment-wrap">
                              <img
                                src={
                                  process.env.PUBLIC_URL + item.assessment_img
                                }
                                alt="assessment-icon"
                                className="assessment-img"
                              />
                              <span
                                className="assessment-span"
                                onClick={() =>
                                  handleAssessment("selenium-" + item.title)
                                }
                              >
                                Take Assessment
                              </span>
                            </div> */}
                                                                <div className="hours-container">
                                                                    <div className="hours-wrap">
                                                                        <img
                                                                            src={
                                                                                process.env.PUBLIC_URL +
                                                                                "/images/Hourglass.png"
                                                                            }
                                                                            alt="Hour-Glass"
                                                                            className="hour-img"
                                                                        />
                                                                        <div className="duration">
                                                                            <p className="duration-title">Duration</p>
                                                                            <p className="duration-hours">
                                                                                {item.duration}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    {/* <div className="progress-wrap">
                                                                <CircularProgressbar
                                                                    value={0}
                                                                    strokeWidth={12}
                                                                // text={`${40}%`}
                                                                />
                                                                <div className="progress-content">
                                                                    <span className="progress-span">0%</span>
                                                                    <p className="progress-p">Completed</p>
                                                                </div>
                                                            </div> */}
                                                                </div>
                                                                <div className="courses-container">
                                                                    <div
                                                                        style={{
                                                                            background: phase == item.title && "#dbdbdb",
                                                                            border:
                                                                                phase == item.title && "1px solid #52297f",
                                                                            borderRadius: phase == item.title && "4px",
                                                                            borderBottom: phase == item.title && "0px",
                                                                        }}
                                                                        className="courses-wrap"
                                                                        onClick={() => {
                                                                            phase == item.title
                                                                                ? setPhase(null)
                                                                                : setPhase(item.title);
                                                                        }}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                color: phase == item.title && "#52297f",
                                                                                fontWeight: phase == item.title && "600",
                                                                            }}
                                                                        >
                                                                            Courses
                                                                        </p>
                                                                        {phase == item.title ? (
                                                                            <img
                                                                                src={
                                                                                    process.env.PUBLIC_URL +
                                                                                    "/images/Home/Courses/Azure/Active.png"
                                                                                }
                                                                                alt="Active"
                                                                                className="courses-arrow-img"
                                                                            />
                                                                        ) : (
                                                                            <img
                                                                                src={
                                                                                    process.env.PUBLIC_URL +
                                                                                    "/images/Home/Courses/Azure/Inactive.png"
                                                                                }
                                                                                alt="Inactive"
                                                                                className="courses-arrow-img"
                                                                            />
                                                                        )}
                                                                    </div>
                                                                    {/* <div
                                                                className="courses-wrap"
                                                                onClick={() =>
                                                                    handleAssessment("selenium-" + item.title)
                                                                }
                                                                style={{
                                                                    border: "1px solid #754bff",
                                                                    color: "#754bff",
                                                                }}
                                                            >
                                                                <p>Take assessment</p>
                                                                <img height={'17px'}
                                                                    src={
                                                                        process.env.PUBLIC_URL +
                                                                        "/images/Home/Courses/Azure/assess_icon.png"
                                                                    }
                                                                    alt="Assessment"
                                                                    className="courses-arrow-img"
                                                                />
                                                            </div> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className={
                                                            phase == item.title
                                                                ? "card-panel-outer-active"
                                                                : "card-panel-outer"
                                                        }
                                                    >
                                                        <div
                                                            className={
                                                                phase == item.title
                                                                    ? "card-panel-active"
                                                                    : "card-panel"
                                                            }
                                                        >
                                                            <div
                                                                className={
                                                                    phase == item.title
                                                                        ? "card-panel-internal-active"
                                                                        : "card-panel-internal"
                                                                }
                                                            >
                                                                {item.coursesData &&
                                                                    item.coursesData.map((elem) => (
                                                                        <>
                                                                            <p className="panel-header">{elem.parent}</p>
                                                                            {elem.subCourses &&
                                                                                elem.subCourses.map((val) => {
                                                                                    return (
                                                                                        <>
                                                                                            <a
                                                                                                href={val.course_link}
                                                                                                target="_blank"
                                                                                            >
                                                                                                <p>{val.course_name}</p>
                                                                                            </a>
                                                                                        </>
                                                                                    );
                                                                                })}
                                                                        </>
                                                                    ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <Modal
                                                    hideBackdrop
                                                    open={openModal}
                                                    onClose={handleClose}
                                                    aria-labelledby="child-modal-title"
                                                    closeAfterTransition
                                                    aria-describedby="child-modal-description"
                                                    className="modal-container"
                                                >
                                                    <Box className="model">
                                                        <div className="model_heading">
                                                            <h5 className="paramodel">{modalContent.title}</h5>
                                                            <span
                                                                className="close_btn_model"
                                                                onClick={handleClose}
                                                                tabIndex={0}
                                                            >
                                                                Close
                                                            </span>
                                                        </div>
                                                        <hr />
                                                        <div className="mainRootWrapper">
                                                            <div>
                                                                <h6>Description :</h6>
                                                                <p>{modalContent.levelDesc}</p>
                                                                <h6>
                                                                    Duration :<span>{modalContent.duration}</span>
                                                                </h6>
                                                            </div>
                                                            <div>
                                                                <h6>
                                                                    Target Audience :{" "}
                                                                    <span>{modalContent.targetAudience}</span>
                                                                </h6>
                                                            </div>
                                                            {/* <div>
                            <h6>Pre-requisite :</h6>
                            <p dangerouslySetInnerHTML={{ __html: modalContent["pre-requisite"] }}></p>
                           </div> */}
                                                        </div>
                                                    </Box>
                                                </Modal>
                                            </>
                                        );
                                    })}
                            </div>


                        }

                    </div>
                    {/* Program Highlights Section */}
                    <div className="program-highlights-container">
                        <div className="program-highlights-wrap">
                            <center><h2>Program Highlights</h2></center>

                            {isAdmin &&
                                <center><Button style={{ color: "black", textTransform: 'none' }}
                                    variant="outlined" size="small" onClick={() => setEditable(5)}>
                                    <img height="12px" src={process.env.PUBLIC_URL + "/images/Home/Courses/Azure/EditIcon.png"} />
                                    &nbsp;Edit</Button></center>}
                            {editable === 5 ?
                                <FormGroup>

                                    {arr1.map((item, index) => (
                                        <FormControlLabel
                                            key={index}
                                            control={<Checkbox checked={highlightsChecklist[index]} onChange={handleCheckboxChange(index)} />}
                                            label={item.text}
                                        />
                                    ))}

                                    <div className={styles.center}>
                                        <Button className={styles.btn} variant="contained" color="primary" onClick={handleHighlightsSubmit}>
                                            Save
                                        </Button>
                                        <Button variant="outlined" className={styles.btn} color="error" onClick={() => handleAbort(5)}>
                                            Cancel
                                        </Button>
                                    </div>
                                </FormGroup>
                                :
                                <div className={`${styles.marginTop} program-highlights-section`}>

                                    {rdata.program_highlights !== undefined
                                        && rdata.program_highlights.length > 0 ?

                                        rdata.program_highlights.map(highlight => (

                                            <div className="program-card">
                                                <img
                                                    src={
                                                        process.env.PUBLIC_URL +
                                                        arr1[highlight].image
                                                    }
                                                    alt={highlight}
                                                    className=""
                                                />
                                                <p>{arr1[highlight].text}</p>
                                            </div>

                                        )) : <h3 className={styles.nothing}>No Hightlights to display</h3>
                                    }


                                </div>}
                        </div>
                    </div>
                </div>
                {/* <InstructionsPopup
                    showInstructionModal={showInstructionModal}
                    setShowInstructionModal={setShowInstructionModal}
                    assessmentCourse={assessmentCourse}
                    setAssessmentCourse={setAssessmentCourse}
                /> */}
            </>
        </ThemeProvider>
        </>
    );
}

export default SkeletonComponent;